// extracted by mini-css-extract-plugin
export default {"page":"ConversationHistoryPage_page__2w1Qw","pageContainer":"ConversationHistoryPage_pageContainer__BhlJ9"};